/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

// TODO : needs to use moment
export default {
  now: new Date(),

  startOfYear: function (year) {
    return new Date(
      year || this.now.getFullYear(),
      0,
      this.now.getFullYear() == 2017 ? 3 : 1
    );
  },

  endOfYear: function (year) {
    return new Date(year || this.now.getFullYear(), 11, 31);
  },

  priorYearStart: function () {
    let lastYear = this.now.getFullYear() - 1;
    return new Date(lastYear, 0, lastYear == 2017 ? 3 : 1);
  },

  monthsFrom: function (date, months) {
    let from = new Date(date.getTime());
    from.setMonth(from.getMonth() - months);
    from.setDate(from.getDate() + 1);
    return from;
  },

  daysFrom: function (date, days) {
    let from = new Date(date.getTime());
    from.setDate(from.getDate() - days);
    return from;
  },

  monthsFromNow: function (months) {
    let date = new Date(this.now.getTime());
    date.setMonth(this.now.getMonth() - months);
    return date;
  },

  daysBeforeNow: function (days) {
    let date = new Date(this.now.getTime());
    date.setDate(date.getDate() - days);
    return date;
  },

  months3Letter: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],

  formatDate: function (date) {
    return date == undefined
      ? ''
      : this.months3Letter[date.getMonth()] +
      ' ' +
      date.getDate() +
      ', ' +
      date.getFullYear();
  },

  getFirstBusinessDayOfTheYear: function () {
    let secondDayOfTheYear = new Date(this.now.getFullYear(), 0, 2);
    let getDay = secondDayOfTheYear.getDay();
    let isBusinessDay = getDay != 0 && getDay != 6;

    if (isBusinessDay) {
      return secondDayOfTheYear;
    }

    // add 3 if Jan 2nd is a Saturday, add 2 if Jan 2nd is a Sunday
    return secondDayOfTheYear.setDate(secondDayOfTheYear.getDate() + (getDay === 6 ? 3 : 2));
  },

  getNinthDayOfTheYear: function () {
    return new Date(this.now.getFullYear(), 0, 9);
  },

  withinDays: function (startDate, endDate, days) {
    let minDate = new Date(endDate.getTime());
    minDate.setDate(minDate.getDate() - days);
    return startDate < minDate;
  },

  getCurrentYear: function () {
    return this.now.getFullYear();
  }
};
